import React, { useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'
import { useIntl } from 'react-intl'
import { toast } from 'react-toastify'
import styled from '@emotion/styled'
import { LinearProgress } from '@mui/material'
import { teacherApiSlice } from '../../../features/teacher/teacherSlice'
import { userApiSlice } from '../../../features/user/userSlice'
import { H3 } from '../../../layouts/TextStyles'
import AddTeacherDialog from './components/AddTeacherDialog'
import TeachersTable from './components/TeachersTable'

const TeacherListPage = () => {
    const { formatMessage } = useIntl()
    const [searchParams, setSearchParams] = useSearchParams('')
    const [page, setPage] = React.useState(
        Number(searchParams.get('page')) || 1,
    )
    const [rowsPerPage, setRowsPerPage] = React.useState(
        Number(searchParams.get('size')) || 5,
    )
    const {
        data: teacherResponse = null,
        isFetching,
        refetch,
    } = teacherApiSlice.useFetchAllTeachersQuery({
        query: `page=${page - 1}&size=${rowsPerPage}`,
        roles: ['TEACHER', 'CURATOR'],
    })
    const [deleteTeacher, { isLoading: isDeleting }] =
        userApiSlice.useDeleteUserMutation()
    const [resetTemporaryPassword, { isLoading: isReseting }] =
        userApiSlice.useResetTemporaryPasswordMutation()

    const handleDelete = async (id: number) => {
        try {
            await deleteTeacher(id).unwrap()
            toast.success(formatMessage({ id: 'deletedSuccess' }))
            refetch()
        } catch (error) {}
    }

    const handleResetPassword = async (id: number) => {
        try {
            await resetTemporaryPassword(id).unwrap()
            toast.success(formatMessage({ id: 'savedSuccess' }))
            refetch()
        } catch (error) {}
    }

    useEffect(() => {
        const params = {
            page: page.toString(),
            size: rowsPerPage.toString(),
        }
        setSearchParams(params)
    }, [rowsPerPage, page])

    //  TODO: add loadings
    //  TODO2: add breadcrumbs

    return (
        <Wrapper>
            <Content>
                <Header>
                    <Title>
                        <H3>{formatMessage({ id: 'teachers' })}</H3>
                    </Title>

                    <AddTeacherDialog />
                </Header>

                {isFetching || isReseting || isDeleting ? (
                    <LinearProgress />
                ) : (
                    teacherResponse && (
                        <TeachersTable
                            isFetching={isFetching || isReseting}
                            teachersData={teacherResponse?.data}
                            pageNumber={teacherResponse?.pageNumber}
                            totalCount={teacherResponse?.totalCount}
                            page={page}
                            rowsPerPage={rowsPerPage}
                            setPage={setPage}
                            setRowsPerPage={setRowsPerPage}
                            onDelete={handleDelete}
                            onResetPassword={handleResetPassword}
                        />
                    )
                )}
            </Content>
        </Wrapper>
    )
}

export default TeacherListPage

const Wrapper = styled.div`
    margin: 10px;
    border-radius: 16px;
`
const Title = styled.div`
    margin-bottom: 20px;
    text-align: left;
    display: flex;
    align-items: center;
`

const Content = styled.div`
    background-color: #fff;
    border-radius: 16px;
    padding: 20px;
    min-height: 80vh;
`

const Header = styled.header`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
`
